/* eslint-disable no-const-assign */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-useless-return */
import { useState } from 'react';

// project-imports
import { dispatch, useSelector } from 'store';
import { getAutosuggestAssigneeData } from 'store/slices/internalCommenting';
import PropTypes from 'prop-types';

// material-ui
import Autocomplete from '@mui/material/Autocomplete';
import SearchIcon from '@mui/icons-material/Search';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import { devConsolelog } from 'helpers/utilityFunctions';

const AutoCompleteAssigneeSearch = ({ formik, isDetailsFlow = false }) => {
    const memberListData = useSelector((state) => state?.internalCommenting);
    const { autosuggestAssigneeData = [] } = memberListData || {};

    const [showDropdownData, setShowDropdownData] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleFilterData = (e, val) => {
        const { email = '', username = '', id = '' } = val || {};
        if (isDetailsFlow) {
            formik.setFieldValue('assigned_to', id);
            formik.setFieldValue('assigned_to_name', username);
        } else if (email) {
            formik.setFieldValue('assigned_to', email);
            formik.setFieldValue('assigned_to_name', username);
        } else if (!email) {
            setShowDropdownData(false);
            formik.setFieldValue('assigned_to', '');
            formik.setFieldValue('assigned_to_name', username);
        }
    };

    const handleSearch = async (searchedValue = null) => {
        devConsolelog('searched keyword', searchedValue, searchedValue.length);

        if (searchedValue.length > 2) {
            setShowDropdownData(false);
            setLoading(true);
            await dispatch(getAutosuggestAssigneeData(searchedValue));
            setShowDropdownData(true);
            setLoading(false);
        } else {
            setShowDropdownData(false);
            setLoading(false);
        }
    };

    const onBlur = () => {
        setShowDropdownData(false);
    };

    return (
        <Autocomplete
            id="assign-to"
            options={!loading && showDropdownData ? autosuggestAssigneeData : []}
            loading={loading}
            onBlur={onBlur}
            value={formik.values?.assigned_to_name || null}
            filterOptions={(options) => options}
            onChange={(event, newValue) => {
                handleFilterData(event, newValue);
            }}
            label={
                <Grid
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap'
                    }}
                >
                    <SearchIcon fontSize="small" />
                    <span>&nbsp;Assignee</span>
                </Grid>
            }
            margin="normal"
            renderInput={(params) => (
                <TextField
                    {...params}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                    label="Assignee"
                    onChange={(e) => {
                        devConsolelog('searched_value', e.target.value);
                        handleSearch(e.target.value);
                    }}
                />
            )}
        />
    );
};

AutoCompleteAssigneeSearch.propTypes = {
    handleSearchByCity: PropTypes.func,
    search: PropTypes.string,
    formik: PropTypes.object
};

export default AutoCompleteAssigneeSearch;
